import {
  AiOutlineUser,
  AiOutlineTransaction,
  AiOutlineMail,
  AiOutlineTeam,
  AiOutlineHome,
  AiOutlineDollar,
  AiOutlineTool,
  AiOutlineCreditCard,
  AiOutlineSchedule,
  AiOutlineFileText,
  AiOutlineSafetyCertificate,
  AiOutlineSolution,
  AiOutlineCustomerService
} from 'react-icons/ai';
export const properties = {
  titles: {
    myProfile: 'My Profile',
    userList: 'User',
    groups: 'Groups',
    pastSafety: 'Upload Past Safety',
    accuracy: 'Prediction Accuracy',
    logout: 'Log out'
  },
  seeSome: 'See Something',
  saySome: 'Say Something',
  userType: {
    admin: 'Admin',
    groupOwner: 'Group Owner',
    groupManager: 'Group Manager'
  },
  links: {
    superAdmin: [
      {
        title: 'Transaction',
        link: '/superadmin/transaction',
        icon: <AiOutlineTransaction size={24} />
      },
      {
        title: 'Contact Us Messages',
        link: '/superadmin/contact',
        icon: <AiOutlineMail size={24} />
      },
      {
        title: 'Invitations',
        link: '/superadmin/invitations',
        icon: <AiOutlineTeam size={24} />
      },
      {
        title: 'Plans',
        link: '/superadmin/plan',
        icon: <AiOutlineSolution size={24} />
      },
      {
        title: 'Access Requests',
        link: '/superadmin/access-requests',
        icon: <AiOutlineSafetyCertificate size={24} />
      }
    ],
    admin: [
      {
        title: 'Landlords',
        link: '/admin/landlord',
        icon: <AiOutlineUser size={24} />
      },
      {
        title: 'Tenants',
        link: '/admin/tenant',
        icon: <AiOutlineUser size={24} />
      },
      {
        title: 'Invitations',
        link: '/admin/invitations',
        icon: <AiOutlineTeam size={24} />
      },
      {
        title: 'Properties',
        link: '/admin/property',
        icon: <AiOutlineHome size={24} />
      },
      {
        title: 'Transactions',
        link: '/admin/transaction',
        icon: <AiOutlineTransaction size={24} />
      },
      {
        title: 'Subscriptions',
        link: '/admin/subscriptions',
        icon: <AiOutlineCreditCard size={24} />
      },
      {
        title: 'Landlord Plans',
        link: '/admin/plan',
        icon: <AiOutlineSolution size={24} />
      },
      {
        title: 'Access Requests',
        link: '/admin/access-requests',
        icon: <AiOutlineSafetyCertificate size={24} />
      }
    ],
    landLord: [
      {
        title: 'Tenants',
        link: '/landlord/tenant',
        icon: <AiOutlineUser size={24} />
      },
      {
        title: 'Properties',
        link: '/landlord/property',
        icon: <AiOutlineHome size={24} />
      },
      {
        title: 'Invitations',
        link: '/landlord/invitations',
        icon: <AiOutlineTeam size={24} />
      },
      {
        title: 'Service Requests',
        link: '/landlord/service-request',
        icon: <AiOutlineTool size={24} />
      },
      {
        title: 'Invoices',
        link: '/landlord/invoices',
        icon: <AiOutlineFileText size={24} />
      },
      {
        title: 'Transactions',
        link: '/landlord/transaction',
        icon: <AiOutlineTransaction size={24} />
      },
      {
        title: 'Subscriptions',
        link: '/landlord/subscriptions',
        icon: <AiOutlineCreditCard size={24} />
      },
      {
        title: 'Property Management',
        link: '/landlord/property-managers',
        icon: <AiOutlineHome size={24} />
      }
    ],
    manager: [
      {
        title: 'Property',
        link: '/manager/property',
        icon: <AiOutlineHome size={24} />
      },
      {
        title: 'Invoices',
        link: '/manager/invoices',
        icon: <AiOutlineFileText size={24} />
      },
      {
        title: 'Rent',
        link: '/manager/rent',
        icon: <AiOutlineDollar size={24} />
      },
      {
        title: 'Transaction',
        link: '/manager/transaction',
        icon: <AiOutlineTransaction size={24} />
      },
      {
        title: 'Service Request',
        link: '/manager/service-request',
        icon: <AiOutlineTool size={24} />
      }
    ],
    tenant: [
      {
        title: 'Landlord',
        link: '/tenant/landlord',
        icon: <AiOutlineUser size={24} />
      },
      { title: 'Property', link: '/tenant/property', icon: <AiOutlineHome /> },
      {
        title: 'Rent',
        link: '/tenant/rent',
        icon: <AiOutlineDollar size={24} />
      },
      {
        title: 'Invitations',
        link: '/tenant/invitations',
        icon: <AiOutlineTeam size={24} />
      },
      {
        title: 'Property Management',
        link: '/tenant/management',
        icon: <AiOutlineHome size={24} />
      },
      {
        title: 'Service Request',
        link: '/tenant/service-request',
        icon: <AiOutlineTool size={24} />
      },
      {
        title: 'Transaction',
        link: '/tenant/transaction',
        icon: <AiOutlineTransaction size={24} />
      }
    ]
  }
};

export const dataTypes = [
  { title: 'Documents', to: '/documents' },
  { title: 'Assistant', to: '/assistant' },
  { title: 'Forecasting', to: '/forecasting  ' },
  { title: 'NPCon', to: '/npcon' },
  { title: 'Past Crime', to: '/past-crime' },
  { title: 'Law Enforcement', to: '/dashboard/c' }
];

export const getLinks = (user) => {
  if (user === 'SuperAdmin') {
    return properties.links.superAdmin;
  }
  if (user === 'Admin') {
    return properties.links.admin;
  }
  if (user === 'Landlord') {
    return properties.links.landLord;
  }
  if (user === 'Tenant') {
    return properties.links.tenant;
  }
  if (user === 'Manager') {
    return properties.links.manager;
  }
};
